import React, {useEffect, useRef, useState} from 'react';
import styles from './SearchBar.module.css';
import SearchWithAiButton from "../SearchWithAiButton/SearchWithAiButton";
import NobiEventTracker from "../../utils/NobiEventTracker";
import Events from "../../utils/Events";
import {EntryPoint} from "../Chatbot/EntryPoint";

const preloadChatbot = () => {
    import('../Chatbot/Chatbot');
};

const SearchBar = ({ merchantId, onSearchSubmitted, onQueryUpdated, brandTheme, isDrawerOpen, isSearchBarVisible }) => {
    const [query, setQuery] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current && !isDrawerOpen) {
            inputRef.current.focus();
        }
    }, []);

    useEffect(() => {
        if (!isDrawerOpen && inputRef.current && isSearchBarVisible) {
            inputRef.current.focus();
        }
    }, [isDrawerOpen, isSearchBarVisible]);

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                NobiEventTracker.trackEvent(merchantId, EntryPoint.SearchBar, Events.Search, false, true, null, { query: query, searchEngine: "Nobi" });
                NobiEventTracker.trackEvent(merchantId, EntryPoint.SearchBar, Events.SearchOnNobi, false, true, null, { query: query });
                NobiEventTracker.trackEvent(merchantId, EntryPoint.SearchBar, Events.SendMessage, false, true, null, { query: query });
                onSearchSubmitted();
                setQuery('');
            }}
            id={"nobi-search-form"}
            className={styles.form}
            aria-label="Search Form"
        >
            <div className={styles.inputWrapper}>
                <input
                    ref={inputRef}
                    type="text"
                    placeholder="What are you looking for?"
                    value={query}
                    onChange={(e) => {
                        setQuery(e.target.value);
                        onQueryUpdated(e.target.value);
                        preloadChatbot();
                    }}
                    onFocus={preloadChatbot}
                    required
                    className={styles.input}
                    aria-label="Search Query"
                />
            </div>
            <SearchWithAiButton
                merchantId={merchantId}
                brandTheme={brandTheme}
                buttonLabel={"Search With AI"}
                isSubmitForForm={true} />
        </form>
    );
};

export default SearchBar;
